/**
 * Created by jonas on 2021-03-05.
 */

import * as PIXI from "pixi.js";
import {gsap} from "gsap";
import {MechanicalCounter, MechanicalCounterTextureSet} from "./MechanicalCounter";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootGameAssets} from "../../DasUBootGameAssets";
import {DasUBootSound} from "../../sound/DasUBootSound";

export class PossibleWinWaysDisplayCounter extends PIXI.Container {

    private counter:MechanicalCounter;

    constructor() {
        super();
        this.init();
    }

    private init() {
        const textures:MechanicalCounterTextureSet = {
            background:DasUBoot.assetLoader.getTextures(DasUBootGameAssets.WIN_WAYS_COUNTER_BG)[0],
            numbers:DasUBoot.assetLoader.getTextures(DasUBootGameAssets.WIN_WAYS_COUNTER_NUMBERS)[0],
            overlay:DasUBoot.assetLoader.getTextures(DasUBootGameAssets.WIN_WAYS_COUNTER_OVERLAY)[0],
        }

        this.counter = new MechanicalCounter(5, textures, new PIXI.Point(15,28), 16);
        this.addChild(this.counter);
        this.setWinWays(576, true);
    }


    public setWinWays(ways:number = 1, skipSound:boolean = false):gsap.core.Timeline {
        const tl = this.counter.setValue(ways);
        if (tl.duration() > 0 && !skipSound){
            tl.add(()=>DasUBoot.reelView.reelFrame.playWinWaysSteam(),0);
            tl.add(()=>DasUBoot.soundPlayer.playSound(DasUBootSound.POSSIBLE_WIN_WAYS_DISPLAY_TICK),0);
        }
        return tl;
    }
}